namespace Roodik.Core
{
	export class GoogleImpl
	{
		constructor(private _appId:string)
		{
			this.init();
		}
		
		private init()
		{
			window["_GameGATracker"]('create', this._appId, 'auto');
		}
		
		public sendPageview(eventName, params)
		{
			window["_GameGATracker"]("send", "pageview", params);
		};
		
		public sendEvent(eventCategory:string, eventAction:string, eventLabel:string, eventValue:number, dimensions:Object)
		{
			if(window["_GameGATracker"])
			{
				window["_GameGATracker"]("send", "event", eventCategory, eventAction, eventLabel, eventValue, dimensions);
			}
		};
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Analytics/Impl/GoogleImpl.ts